import React, {createRef} from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import BaseComponent from "../../gd-components/base-component/base-component";

import TreeCompanyView from './components/tree-company-view';
import TreeProjectView from './components/tree-project-view';
import VScroll from '../../gd-components/scrolling/custom-v-scroll/v-scroll';

const debug = false
// const debug = "GDTreeSingle"

export default class GDTreeSingle extends BaseComponent {
    static propTypes = {
        source                          : PropTypes.object.isRequired,

        companies                       : PropTypes.array,
        expanded                        : PropTypes.shape({
                                            companies: PropTypes.array,
                                            projects: PropTypes.array
                                        }),

        value                           : PropTypes.shape({
                                            companyId: PropTypes.string,
                                            projectId: PropTypes.string
                                        }),

        filterProjects                  : PropTypes.arrayOf(PropTypes.shape({
                                            counter: PropTypes.number,
                                            item: PropTypes.object
                                        })),

        ignoredParentProjects           : PropTypes.array,

        unselectLabel                   : PropTypes.string,

        companiesSelectable             : PropTypes.bool,
        singleCompanyVisible            : PropTypes.bool,
        showEmptyCompanies              : PropTypes.bool,
        showOnlyFilterProjects          : PropTypes.bool,
        showGhostParents                : PropTypes.bool,
        showCompanyIcon                 : PropTypes.bool,
        showProjectIcon                 : PropTypes.bool,
        showProjectIconColorized        : PropTypes.bool,
        noCollapseExpand                : PropTypes.bool,
        scrollContentStyle              : PropTypes.object,
        updateExpandedOnReceiveProps    : PropTypes.bool,
        noScroll                        : PropTypes.bool,
        scrollToSelected                : PropTypes.bool,
        selectable                      : PropTypes.bool,
        highlightOnHover                : PropTypes.bool,

        onToggleExpand                  : PropTypes.func,
        onChange                        : PropTypes.func.isRequired,
        onTab                           : PropTypes.func,
    };

    static defaultProps = {
        expanded                        : {},
        ignoredParentProjects           : [],
        companiesSelectable             : true,
        singleCompanyVisible            : true,
        showEmptyCompanies              : true,
        showGhostParents                : true,
        updateExpandedOnReceiveProps    : true,
        noScroll                        : false,
        selectable                      : true
    };

    constructor(props) {
        super(props)

        this.optionsLength = 0
        this.selectedItemKey = null

        this.state = {
            currentCursorKey    : null,
            expanded            : this.initialItemsExpand(this.props),
            value               : this.props.value,
            projectsToShow      : this.getProjectsToShow(this.props)
        }

        this.scrollRef          = createRef()
        this.selectedProjectRef = createRef()
        this.highligtedItemRef  = createRef()
    }

    componentDidMount() {
        if (this.props.scrollToSelected &&
            this.props.value &&
            !this.props.noScroll &&
            this.scrollRef.current &&
            this.selectedProjectRef.current) {
            const node = findDOMNode(this.selectedProjectRef.current)
            if (node) this.scrollRef.current.setScrollTop(node.offsetTop, true, 0);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { updateExpandedOnReceiveProps } = nextProps;
        this.setState({
            expanded: updateExpandedOnReceiveProps ? this.initialItemsExpand(nextProps) : this.state.expanded,
            value: nextProps.value,
            projectsToShow: this.getProjectsToShow(nextProps)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        debug && console.log(debug, 'componentDidUpdate', this.state.currentCursorKey)

        if (this.scrollRef.current) {
            if (!_.isNil(this.state.currentCursorKey) && this.state.currentCursorKey !== prevState.currentCursorKey) {
                const node = findDOMNode(this.highligtedItemRef.current)
                if (node) {
                    this.scrollRef.current?.setScrollTop(node.offsetTop + node.clientHeight/2,true,250)
                }
            }
        }
    }

    onKeyDown = (event) => {
        debug && console.log(debug, 'onKeyDown', this.state.currentCursorKey, event)

        let newValue
        switch(event.code){
            case 'Tab':
                event.preventDefault()
                this.props.onTab && this.props.onTab()
                break

            case 'ArrowUp':
                if (_.isNil(this.state.currentCursorKey)) {
                    newValue = this.selectedItemKey ? this.selectedItemKey - 1 : 0
                } else {
                    newValue = this.state.currentCursorKey - 1
                    if (newValue < 0) newValue = 0
                }

                this.setState({
                    currentCursorKey: newValue
                })
                break

            case 'ArrowDown':
                if (_.isNil(this.state.currentCursorKey)) {
                    newValue = this.selectedItemKey ? this.selectedItemKey + 1 : 0
                } else {
                    newValue = this.state.currentCursorKey + 1
                    if (newValue > this.optionsLength - 1) newValue = this.optionsLength - 1;
                }

                this.setState({
                    currentCursorKey: newValue
                })
                break

            case 'ArrowLeft':
            case 'ArrowRight':
                event.preventDefault()
                event.stopPropagation()

                if (this.highligtedItemRef.current) this.highligtedItemRef.current.toggleExpand()
                break

            case 'Enter':
                event.preventDefault()
                event.stopPropagation()

                if (this.highligtedItemRef.current) this.highligtedItemRef.current.click()
                break
        }
    }

    getProjectsToShow = (props) => {
        let projectsToShow = null;
        if (props.showOnlyFilterProjects) {
            projectsToShow = [];
            props.filterProjects && props.filterProjects.map(fp=>{
                const project = props.source.getProject(fp.item.id);
                const parentsIds = props.showGhostParents ? props.source.findProjectParents(project).map(p=>p.id) : [];
                projectsToShow = projectsToShow.concat([fp.item.id]).concat(parentsIds);
            });

            projectsToShow = _.uniq(projectsToShow);
        }

        return projectsToShow;
    };

    initialItemsExpand = (props) => {
        let toExpand = [];
        toExpand = toExpand.concat(props.expanded.companies ? props.expanded.companies.map(id=>"c_"+id) : []);
        toExpand = toExpand.concat(props.expanded.projects ? props.expanded.projects.map(id=>"p_"+id) : []);

        if (props.value) {
            const project = props.source.getProject(props.value.projectId);

            if (project) {
                toExpand = toExpand.concat(props.source.findProjectParents(project).map(p=>"p_"+p.id));
                toExpand.unshift("c_"+project.companyId);
            }
        }

        return toExpand;
    };

    onToggleExpand = (id) => {
        const oldIsExpanded = this.state.expanded.includes(id);
        const newIsExpanded = !oldIsExpanded;

        const newExpanded = this.state.expanded.slice(0);

        if (newIsExpanded)  newExpanded.push(id);
        else                newExpanded.remove(id);

        this.setState({expanded: newExpanded});
        if (this.props.onToggleExpand) this.props.onToggleExpand(id, newIsExpanded);
    };

    onClickUnselect = () => {
        if (this.props.selectable) {
            this.setState({value: null}, ()=>{this.props.onChange(null)});
        }
    };

    onProjectClick = (project) => {
        const value = {
            projectId: project.id,
            companyId: project.companyId
        };

        if (this.props.selectable) {
            this.setState({value: value}, ()=>{this.props.onChange(value)});
        } else {
            this.props.onChange(value);
        }
    };

    onCompanyClick = (companyId) => {
        if (this.props.companiesSelectable) {
            const value = {
                projectId: null,
                companyId: companyId
            };

            if (this.props.selectable) {
                this.setState({value: value}, ()=>{this.props.onChange(value)});
            } else {
                this.props.onChange(value);
            }

        } else {
            if (!this.props.noCollapseExpand)
                this.onToggleExpand("c_"+companyId);
        }
    };

    renderCompanyTree = (model) => {

        let itemKey             = 0
        let selectedCompanies   = [];
        let selectedProjects    = [];

        if (this.state.value) {
            if (this.state.value.projectId)        selectedProjects.push(this.state.value.projectId);
            else if (this.state.value.companyId)   selectedCompanies.push(this.state.value.companyId);
        }

        const renderTree = (level, parent)=>{
            let items = [];

            if (parent.projects) items = parent.projects;
            else items = parent.children ? parent.children : [];

            items.map((i)=>{
                const p = i.project;
                const filteredOut = this.state.projectsToShow && !this.state.projectsToShow.includes(p.id);

                if (!filteredOut) {

                    //do not render ignored parent and render its children shifted one level up
                    if (!this.props.ignoredParentProjects.includes(p.id)) {
                        const filterItem = this.props.filterProjects ? this.props.filterProjects.find(fp=>fp.item.id === p.id) : null;
                        const expandable = !!i.children.length > 0 &&
                            (!this.state.projectsToShow || _.intersection(i.children.map(c=>c.project.id), this.state.projectsToShow).length > 0);

                        const isExpanded = this.state.expanded.includes("p_"+p.id);
                        const isSelected = selectedProjects.indexOf(p.id) !== -1;

                        if (isSelected && !this.selectedItemKey) this.selectedItemKey = itemKey
                        const isHighlighted = !_.isNil(this.state.currentCursorKey) ? itemKey === this.state.currentCursorKey : itemKey === this.selectedItemKey
                        itemKey++

                        res.push(<TreeProjectView ref={r=>{
                                                      if (isSelected)       this.selectedProjectRef.current = r
                                                      if (isHighlighted)    this.highligtedItemRef.current = r
                                                  }}
                                                  key                       = {p.id}
                                                  project                   = {p}
                                                  counter                   = {filterItem ? filterItem.counter : null}
                                                  selectable                = {!filterItem || !filterItem.notSelectable}
                                                  expandable                = {expandable}
                                                  isHighlighted             = {isHighlighted}
                                                  isSelected                = {isSelected}
                                                  isExpanded                = {isExpanded}
                                                  level                     = {level}
                                                  showProjectIcon           = {this.props.showProjectIcon}
                                                  showProjectIconColorized  = {this.props.showProjectIconColorized}
                                                  noCollapseExpand          = {this.props.noCollapseExpand}
                                                  disabled                  = {this.props.showOnlyFilterProjects && !filterItem}
                                                  onClick                   = {this.onProjectClick}
                                                  onToggleExpand            = {this.onToggleExpand}/>);

                        if (expandable && isExpanded) renderTree(level+1,i);
                    } else {
                        renderTree(level,i);
                    }

                } else if (!this.props.showGhostParents) {
                    if (i.children.length > 0) renderTree(level,i);
                }

            });
        };

        const res           = [];
        const isExpanded    = this.state.expanded.includes("c_"+gd.companyId);
        const isSelected    = selectedCompanies.indexOf(gd.companyId) !== -1;
        const showCompany   = this.props.companies.length !== 1 || this.props.singleCompanyVisible;

        if (showCompany) {
            const treeCompanyViewClasses = Classes({
                "not-selectable": !this.props.companiesSelectable
            });

            let counter = null;
            if (this.props.filterProjects) {
                counter = 0;
                model.projects && model.projects.map(p=>{
                    const fItem = this.props.filterProjects.find(fp=>fp.item.id === p.project.id);
                    if (fItem && fItem.counter) counter += fItem.counter;
                });
                counter = counter === 0 ? null : counter;
            }

            const renderCompany = this.props.showEmptyCompanies ||
                (this.props.filterProjects ? !!this.props.filterProjects.find(fp=>fp.item.companyId === gd.companyId) : model.projects.length > 0);

            const expandable = model.projects.length > 0 &&
                (!this.state.projectsToShow || _.intersection(model.projects.map(c=>c.project.id), this.state.projectsToShow).length > 0);

            if (renderCompany) {
                if (isSelected && !this.selectedItemKey) this.selectedItemKey = itemKey
                const isHighlighted = !_.isNil(this.state.currentCursorKey) ? itemKey === this.state.currentCursorKey : itemKey === this.selectedItemKey
                itemKey++

                res.push(
                    <TreeCompanyView ref={r=>{
                                            if (isHighlighted)    this.highligtedItemRef.current = r
                                        }}
                                     key                = {"company_"+gd.companyId}
                                     className          = {treeCompanyViewClasses}
                                     company            = {gd.company}
                                     counter            = {counter}
                                     expandable         = {expandable}
                                     isHighlighted      = {isHighlighted}
                                     isSelected         = {isSelected}
                                     isExpanded         = {isExpanded}
                                     showCompanyIcon    = {this.props.showCompanyIcon}
                                     noCollapseExpand   = {this.props.noCollapseExpand}
                                     onClick            = {this.onCompanyClick}
                                     onToggleExpand     = {this.onToggleExpand}/>
                );

                if (expandable && isExpanded)   renderTree(1, model);
            }
        } else {
            if (model.projects)                 renderTree(0, model);
        }

        this.optionsLength = res.length

        return res;
    };

    renderUnselect = () => {
        const unselectLabelClasses = Classes("gd-tree-item-unselect",{
            'gd-tree-item-selected': !this.state.value
        });

        return this.props.unselectLabel ?
            <div className={unselectLabelClasses} onClick={this.onClickUnselect}>
                <div className="gd-tree-item-name">{this.props.unselectLabel}</div>
            </div>
            : null
    };

    renderNoScroll = () => {
        const classes = Classes('gd-tree', this.props.className, {
            "highlight-on-hover": this.props.highlightOnHover
        });

        return (
            <div className={classes} style={this.props.scrollContentStyle}>
                {this.renderUnselect()}
                {this.props.companies.map(m=>this.renderCompanyTree(m))}
                {this.props.children}
            </div>
        );
    };

    renderDefault = () => {
        const classes = Classes('gd-tree', this.props.className, {
            "highlight-on-hover": this.props.highlightOnHover
        });

        return (
            <VScroll ref={this.scrollRef} className={classes} containerStyle={this.props.scrollContentStyle}>
                {this.renderUnselect()}
                {this.props.companies.map(m=>this.renderCompanyTree(m))}
                {this.props.children}
            </VScroll>
        );
    };

    render() {
        return this.props.noScroll ? this.renderNoScroll() : this.renderDefault();
    }
}
